import {
  CellClassParams,
  ColDef,
  GridOptions,
  ValueFormatterParams,
} from '@ag-grid-community/core';
import { Injectable } from '@angular/core';

import { AgCellWrapperComponent } from '@shared/ag-components/ag-cell-wrapper/ag-cell-wrapper.component';
import { TableConstants } from '@shared/constants/table.constants';
import { MoneyPipe } from '@shared/pipes/money.pipe';
import { Currency } from '@shared/services/gql.service';

import { ForecastTableGridCategoryComponent } from '../components/forecast-table-grid-category/forecast-table-grid-category.component';
import { ForecastTableGridDriverComponent } from '../components/forecast-table-grid-driver/forecast-table-grid-driver.component';
import { ForecastTableGridMethodComponent } from '../components/forecast-table-grid-method/forecast-table-grid-method.component';
import { ForecastTableGridPeriodComponent } from '../components/forecast-table-grid-period/forecast-table-grid-period.component';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridColumnsService {
  gridOptions: GridOptions = {
    autoGroupColumnDef: {
      cellRendererSelector: (params) => {
        if (params.node.group) {
          return {
            component: 'agGroupCellRenderer',
            params: {
              suppressCount: true,
            },
          };
        }

        return {
          component: ForecastTableGridCategoryComponent,
        };
      },
      comparator: (a, b) => {
        const categories = ['Services', 'Discount', 'Pass-through', 'Investigator'];

        return categories.indexOf(a) - categories.indexOf(b);
      },
      equals: (): boolean => {
        return false;
      },
      field: 'categoryName',
      flex: 2,
      headerClass: 'ag-header-align-center font-bold',
      headerName: 'Category Name',
      initialSort: 'asc',
      menuTabs: [],
      minWidth: 325,
      pinned: 'left',
      resizable: true,
      sort: 'asc',
      suppressMovable: true,
    },
    defaultColDef: {
      ...TableConstants.DEFAULT_GRID_OPTIONS.DEFAULT_COL_DEF,
      cellClassRules: {
        'background-light': (params: CellClassParams) => {
          return !!params.node.group;
        },
        'background-white': () => {
          return true;
        },
      },
      cellRenderer: AgCellWrapperComponent,
      sortable: false,
    },
    enableCellTextSelection: true,
    enableRangeSelection: false,
    groupDefaultExpanded: 1,
    headerHeight: TableConstants.HEADER_HEIGHT,
    rowHeight: 55,
    suppressClipboardPaste: true,
    suppressContextMenu: true,
    suppressCopyRowsToClipboard: true,
    suppressMultiRangeSelection: true,
  };

  // eslint-disable-next-line max-lines-per-function
  gridColumns = (orgCurrency: Currency): ColDef[] => [
    {
      field: 'costCategoryType',
      hide: true,
      rowGroup: true,
    },
    {
      field: 'isOpen',
      hide: true,
    },
    {
      cellRenderer: ForecastTableGridCategoryComponent,
      equals: (): boolean => {
        return false;
      },
      field: 'categoryName',
      flex: 2,
      headerClass: 'ag-header-align-center font-bold',
      hide: true,
      menuTabs: [],
      minWidth: 325,
      pinned: 'left',
      resizable: true,
      suppressMovable: true,
    },
    {
      cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
      field: 'total',
      flex: 1,
      headerClass: 'ag-header-align-center font-bold',
      menuTabs: [],
      minWidth: 125,
      resizable: true,
      suppressMovable: true,
      type: 'rightAligned',
      valueFormatter: (params: ValueFormatterParams): string => {
        const moneyFormat = new MoneyPipe().transform(params.value, orgCurrency);

        return params.node?.group ? '' : String(moneyFormat);
      },
    },
    {
      cellClass: TableConstants.STYLE_CLASSES.CELL_ALIGN_RIGHT,
      field: 'remaining',
      flex: 1,
      headerClass: 'ag-header-align-center font-bold',
      menuTabs: [],
      minWidth: 125,
      resizable: true,
      suppressMovable: true,
      type: 'rightAligned',
      valueFormatter: (params: ValueFormatterParams): string => {
        const moneyFormat = new MoneyPipe().transform(params.value, orgCurrency);

        return params.node?.group ? '' : String(moneyFormat);
      },
    },
    {
      field: 'units',
      flex: 0.5,
      headerClass: 'ag-header-align-center font-bold',
      menuTabs: [],
      minWidth: 75,
      resizable: true,
      suppressMovable: true,
    },
    {
      field: 'uom',
      flex: 0.5,
      headerClass: 'ag-header-align-center font-bold',
      headerName: 'UoM',
      menuTabs: [],
      minWidth: 125,
      resizable: true,
      suppressMovable: true,
    },
    {
      cellRenderer: ForecastTableGridDriverComponent,
      equals: (): boolean => {
        return false;
      },
      field: 'driver',
      headerClass: 'ag-header-align-center font-bold',
      maxWidth: 150,
      menuTabs: [],
      minWidth: 150,
      suppressMovable: true,
    },
    {
      cellRenderer: ForecastTableGridPeriodComponent,
      equals: (): boolean => {
        return false;
      },
      field: 'period',
      headerClass: 'ag-header-align-center font-bold',
      maxWidth: 280,
      menuTabs: [],
      minWidth: 280,
      suppressMovable: true,
    },
    {
      cellRenderer: ForecastTableGridMethodComponent,
      equals: (): boolean => {
        return false;
      },
      field: 'method',
      headerClass: 'ag-header-align-center font-bold',
      maxWidth: 230,
      menuTabs: [],
      minWidth: 230,
      suppressMovable: true,
    },
  ];
}
